import { defineComponent as _defineComponent } from 'vue'

import { useI18n } from 'vue-i18n-composable'
import ClosePreviewComponent from '@/components/FileManager/Preview/components/ClosePreviewComponent.vue'

// TRANSLATIONS

export default /*#__PURE__*/_defineComponent({
  __name: 'NotPreviewContentComponent',
  emits: ['close-viewer-event'],
  setup(__props, { expose, emit }) {

const { t } = useI18n()

const texts = {
  mainAdvise: t('components.file_manager.advises.preview_not_valid') as string
}

// EVENTS


// METHODS
function closeViewerEvent() {
  emit('close-viewer-event')
}

function preview() {
  return null
}

expose({
  preview
})

return { __sfc: true,t, texts, emit, closeViewerEvent, preview, ClosePreviewComponent }
}

})